<template>
  <div class="pt-3">
    <v-flex xs12 sm12 md6 lg6>
      <v-text-field
        v-model="user.current_password"
        :append-icon="show1 ? 'visibility_off' : 'visibility'"
        :type="show1 ? 'text' : 'password'"
        name="input-10-1"
        label="Current Password"
        hint="At least 6 characters"
        :rules="[rules.required, rules.min]"
        counter
        @click:append="show1 = !show1"
      ></v-text-field>
    </v-flex>
    <v-flex xs12 sm12 md6 lg6>
      <v-text-field
        v-model="user.new_password"
        :append-icon="show2 ? 'visibility_off' : 'visibility'"
        :type="show2 ? 'text' : 'password'"
        name="input-10-1"
        label="New Password"
        hint="At least 6 characters"
        :rules="[rules.required, rules.min]"
        counter
        @click:append="show2 = !show2"
      ></v-text-field>
    </v-flex>
    <v-flex xs12 sm12 md6 lg16>
      <v-text-field
        v-model="user.new_password_confirmation"
        :append-icon="show3 ? 'visibility_off' : 'visibility'"
        :type="show3 ? 'text' : 'password'"
        name="input-10-1"
        label="New Password Confirmation"
        hint="At least 6 characters"
        :rules="[rules.required, rules.min]"
        counter
        @click:append="show3 = !show3"
      ></v-text-field>
    </v-flex>
    <v-layout align-center justify-end>
      <v-flex xs6>
        <v-btn class="text-capitalize" color="primary" @click="changePassword">Save</v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import {axiosInstance} from '../../axios-auth'

  export default {
    props: ["user_info"],
    data() {
      return {
        rules: {
          required: value => !!value || 'Required.',
          min: v => v.length >= 6 || 'Min 6 characters',
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Invalid e-mail.'
          }
        },
        show1: false,
        show2: false,
        show3: false,
        user: {
          current_password: '',
          new_password: '',
          new_password_confirmation: ''
        }
      }
    },
    name: "ChangePassword",
    methods: {
      changePassword() {
        const self = this,
          url = 'accounts/password/',
          params = {
            old_password: self.user.current_password,
            new_password: self.user.new_password
          };

        if (self.user.new_password === self.user.new_password_confirmation) {
          axiosInstance.put(url, params).then(function (response) {
            self.$toastr.s("Your password was changed successfully!")
            self.user.current_password = "";
            self.user.new_password = "";
            self.user.new_password_confirmation = "";
          }).catch(function (error) {
            // self.$toastr.e(error.response.message)
            self.$toastr.s("There was a problem changing your password")
            console.log(error)
          })
        } else {
          self.$toastr.e("Your new password must match the new password confirmation")
        }

      }
    }
  }
</script>

<style lang="scss">
  .primary--text {
    color: #0033a0 !important;
    caret-color: #0033a0 !important;
  }
</style>




// WEBPACK FOOTER //
// src/components/edit-account/ChangePassword.vue